<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        :data-type="context.type"
    >
        <copy-field
            :value="context.model"
            :icon="icon"
            :qr-code="qrcode"
            @download-qr-code="doDownloadQRCode"
        />
    </div>
</template>

<script>
import CopyField from '@/components/copy-field';
import downloadQRCode from '@/components/mixins/downloadQRCode';

export default {
    mixins: [downloadQRCode],
    components: {
        CopyField,
    },
    props: {
        context: {
            type: Object,
            required: true
        },
        icon: {
            type: String,
            default: 'share-alt',
        },
        qrcode: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

